import { render, staticRenderFns } from "./classroom-filter-group.vue?vue&type=template&id=d6d50a8e&"
import script from "./classroom-filter-group.vue?vue&type=script&lang=js&"
export * from "./classroom-filter-group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports